/** Preserve event time; legacy pushes can only report when they were received. */
export function notificationTimestamp(value: unknown, now = Date.now()): { createdAt: number; eventTime: boolean } {
  const timestamp = typeof value === 'string' && value.trim() ? Date.parse(value) : NaN
  return Number.isFinite(timestamp)
    ? { createdAt: timestamp, eventTime: true }
    : { createdAt: now, eventTime: false }
}
